<template>
    <div>
        <list-jobs :is-train="false"/>
        <list-jobs :is-train="true"/>
    </div>
</template>

<script>
import ListJobs from './ListJobs.vue';

export default {
  name: 'analysis',
  components: {
    ListJobs
  }
};
</script>